export default "__VITE_ASSET__6ioBpoyI__"